import { useDispatch } from "react-redux";
import { addToast } from "../../SharedModule/redux/reducers/ui.reducer";
import eventHandler from "../../SharedModule/utils/eventHandler";
import { ClientsService } from "../services/clients";

export type deleteKeyContactPayload = {
  relationshipId: number;
  keyContactId: number;
  name: string;
};

export const useClientDeleteKeyContact = (
  showModal: (options: any) => Promise<void>,
  closeModal: () => void,
  setActionLoading: Function
) => {
  const dispatch = useDispatch();
  const deleteKeyContact = async (payload: deleteKeyContactPayload) => {
    const options = {
      title: "Remove Key Contact?",
      text: `Are you sure you want to remove ${payload.name}? This will not delete the contact from the Client.`,
      btnLabel: "Yes, Remove Key Contact",
    };
    await showModal(options);
    closeModal();
    setActionLoading(true);

    await ClientsService.deleteKeyContact(
      payload.relationshipId,
      payload.keyContactId
    )
      .then((data) => {
        if (data.success) {
          dispatch(
            addToast({
              mode: "success",
              message: "Key Contact Deleted Successfully",
            })
          );
          eventHandler.dispatch("toast action", { isClosed: false });
          return true;
        } else {
          dispatch(
            addToast({
              mode: "error",
              message: "Something went wrong deleting this key contact",
            })
          );
          eventHandler.dispatch("toast action", { isClosed: false });
          return false;
        }
      })
      .catch(() => {
        dispatch(addToast({ mode: "error", message: "Something went wrong" }));
        eventHandler.dispatch("toast action", { isClosed: false });
        return false;
      });
  };

  return deleteKeyContact;
};
